import { Check } from "lucide-react";
import { FaqItems } from "../faq/FaqItems";
import { FaqMoreLink } from "../product/ProductFAQ";
import { PhoneLink, QuoteButton, SectionHeading, WhatsAppButton } from "./CtaButtons";

export const HomeFAQ = ({ faqs }) => (faqs?.length ? (
  <section id="veelgestelde-vragen" aria-labelledby="faq-title" className="section scroll-mt-24" data-testid="home-faq">
    <div className="container-tight grid gap-10 lg:grid-cols-12 lg:gap-14">
      <div className="lg:col-span-4">
        <SectionHeading id="faq-title" eyebrow="Veelgestelde vragen" title="Goed om te weten"
          lead="Staat uw vraag er niet bij? Stel hem gerust via WhatsApp of bel ons." />
        <div className="mt-6 flex flex-col items-start gap-4">
          <WhatsAppButton location="faq" />
          <PhoneLink location="faq" />
          <FaqMoreLink testid="home-faq-all-link" />
        </div>
      </div>
      <div className="lg:col-span-8"><FaqItems faqs={faqs} testid="faq-item" /></div>
    </div>
  </section>
) : null);

export const EndCTA = () => (
  <section aria-labelledby="cta-title" className="pb-16 sm:pb-20 lg:pb-24" data-testid="home-end-cta">
    <div className="container-tight">
      <div className="relative overflow-hidden rounded-3xl bg-ink px-6 py-12 sm:px-12 sm:py-16 lg:px-16">
        <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h2 id="cta-title" className="h2 !text-white">Toe aan nieuwe kozijnen?</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">
              Vraag vrijblijvend een prijsindicatie aan. Stuur gerust foto's mee, dan kunnen we u direct gericht adviseren.
            </p>
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[14px] text-slate-300">
              {["Gratis inmeten", "Geen verplichtingen", "Persoonlijk advies"].map((t) => (
                <li key={t} className="inline-flex items-center gap-1.5"><Check className="h-4 w-4 text-[#7FD3D6]" aria-hidden="true" /> {t}</li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-3 sm:items-start lg:col-span-5 lg:items-end">
            <QuoteButton location="end-cta" className="w-full sm:w-auto" />
            <WhatsAppButton location="end-cta" dark className="w-full sm:w-auto" />
            <PhoneLink location="end-cta" dark />
          </div>
        </div>
      </div>
    </div>
  </section>
);
